module.exports = __webpack_public_path__ + "static/img/areaA-15.53aa30b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/areaA-15.png
// module id = 926
// module chunks = 1